export var BookingsStatus;
(function (BookingsStatus) {
    BookingsStatus[BookingsStatus["Initial"] = 0] = "Initial";
    BookingsStatus[BookingsStatus["Fetching"] = 1] = "Fetching";
    BookingsStatus[BookingsStatus["FetchSuccess"] = 2] = "FetchSuccess";
    BookingsStatus[BookingsStatus["FetchingPendings"] = 3] = "FetchingPendings";
    BookingsStatus[BookingsStatus["FetchPendingsSuccess"] = 4] = "FetchPendingsSuccess";
    BookingsStatus[BookingsStatus["FetchingWithStaffIssues"] = 5] = "FetchingWithStaffIssues";
    BookingsStatus[BookingsStatus["FetchWithStaffIssuesSuccess"] = 6] = "FetchWithStaffIssuesSuccess";
    BookingsStatus[BookingsStatus["FetchingClient"] = 7] = "FetchingClient";
    BookingsStatus[BookingsStatus["FetchClientSuccess"] = 8] = "FetchClientSuccess";
    BookingsStatus[BookingsStatus["FetchingClientPendings"] = 9] = "FetchingClientPendings";
    BookingsStatus[BookingsStatus["FetchClientPendingsSuccess"] = 10] = "FetchClientPendingsSuccess";
    BookingsStatus[BookingsStatus["FetchingClientWithStaffIssues"] = 11] = "FetchingClientWithStaffIssues";
    BookingsStatus[BookingsStatus["FetchClientWithStaffIssuesSuccess"] = 12] = "FetchClientWithStaffIssuesSuccess";
    BookingsStatus[BookingsStatus["Getting"] = 13] = "Getting";
    BookingsStatus[BookingsStatus["GetSuccess"] = 14] = "GetSuccess";
    BookingsStatus[BookingsStatus["GettingInvoiceBooking"] = 15] = "GettingInvoiceBooking";
    BookingsStatus[BookingsStatus["GetInvoiceBookingSuccess"] = 16] = "GetInvoiceBookingSuccess";
    BookingsStatus[BookingsStatus["Confirming"] = 17] = "Confirming";
    BookingsStatus[BookingsStatus["ConfirmSuccess"] = 18] = "ConfirmSuccess";
    BookingsStatus[BookingsStatus["ConfirmingAppointment"] = 19] = "ConfirmingAppointment";
    BookingsStatus[BookingsStatus["ConfirmAppointmentSuccess"] = 20] = "ConfirmAppointmentSuccess";
    BookingsStatus[BookingsStatus["Canceling"] = 21] = "Canceling";
    BookingsStatus[BookingsStatus["CancelSuccess"] = 22] = "CancelSuccess";
    BookingsStatus[BookingsStatus["Deleting"] = 23] = "Deleting";
    BookingsStatus[BookingsStatus["DeleteSuccess"] = 24] = "DeleteSuccess";
    BookingsStatus[BookingsStatus["AssignStaffSuccess"] = 25] = "AssignStaffSuccess";
    BookingsStatus[BookingsStatus["UpdatedLocal"] = 26] = "UpdatedLocal";
    BookingsStatus[BookingsStatus["RemovedLocal"] = 27] = "RemovedLocal";
    BookingsStatus[BookingsStatus["RemovedSeveralLocal"] = 28] = "RemovedSeveralLocal";
    BookingsStatus[BookingsStatus["CanceledSeveralLocal"] = 29] = "CanceledSeveralLocal";
    BookingsStatus[BookingsStatus["Locking"] = 30] = "Locking";
    BookingsStatus[BookingsStatus["LockEnd"] = 31] = "LockEnd";
    BookingsStatus[BookingsStatus["Unlocking"] = 32] = "Unlocking";
    BookingsStatus[BookingsStatus["UnlockSuccess"] = 33] = "UnlockSuccess";
    BookingsStatus[BookingsStatus["UnlockUnauthorized"] = 34] = "UnlockUnauthorized";
    BookingsStatus[BookingsStatus["Error"] = 35] = "Error";
})(BookingsStatus || (BookingsStatus = {}));
